/* eslint-disable no-extend-native */

if (!Array.prototype.findLastIndex) {
  Array.prototype.findLastIndex = function <T>(this: T[], predicate: (value: T, index: number, array: T[]) => boolean, thisArg?: unknown): number {
    if (this == null) {
      throw new TypeError("Array.prototype.findLastIndex called on null or undefined");
    }

    if (typeof predicate !== "function") {
      throw new TypeError("predicate must be a function");
    }

    const array = Object(this) as T[];
    const length = array.length >>> 0;

    for (let i = length - 1; i >= 0; i--) {
      if (predicate.call(thisArg, array[i], i, array)) {
        return i;
      }
    }

    return -1;
  };
}

/* eslint-enable no-extend-native */
